import { render, staticRenderFns } from "./DialogStructuralRequest.vue?vue&type=template&id=beb6fa88&"
import script from "./DialogStructuralRequest.vue?vue&type=script&lang=js&"
export * from "./DialogStructuralRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports